__turbopack_context__.v({
  "companyTitle": "NewOrderCard-module-scss-module__yecegq__companyTitle",
  "container": "NewOrderCard-module-scss-module__yecegq__container",
  "placeholderWrapper": "NewOrderCard-module-scss-module__yecegq__placeholderWrapper",
});
